<template>
  <div class="content-box">
    <fieldset>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.total') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="(mainrec.sliCnt + mainrec.quecnt + mainrec.dsqlcnt) | comma" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row><v-col cols="12" style="height:29px"></v-col></v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"> <p class="label">{{ $t('ssr.title.src.load') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="mainrec.sliCnt | comma" outlined dense hide-details readonly></v-text-field> </v-col>
      </v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"> <p class="label">{{ $t('ssr.title.batch.input.queue') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="mainrec.quecnt | comma" outlined dense hide-details readonly></v-text-field> </v-col>
      </v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"> <p class="label">{{ $t('ssr.title.req.app') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="mainrec.dsqlcnt | comma" outlined dense hide-details readonly></v-text-field> </v-col>
      </v-row>
    </fieldset>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import tabable from './tabable';

export default {
  mixins: [tabable],
  computed: {
    ...mapState('analysis/ssr', ['mainrec']),
  },
};
</script>

<style lang="scss" scoped>
@import './tab';
</style>
